import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Container } from "reactstrap";
import Loader from "../../components/Common/Loader";
//Import List
import UsersList from "../../components/Lists/UsersList";
//Import actions redux
import { getUsers } from "../../store/actions";


class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      usrlist: null
    };
  }

  componentDidMount() {
    this.props.getUsers(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingGetUser === false && prevProps.loadingGetUser === true) {
      let users = this.props.users;
      if (users) {
        this.prepareData(users);
      }
    }
  }

  prepareData(users){
    this.setState({usrlist: users})
  }
  refresh(event){
    event.preventDefault()
    this.setState({usrlist:null})
    this.props.getUsers(this.state.user);

  }
  newUser(event){
    event.preventDefault()
    this.props.history.push("/createuser")
  }
  render() {
    if (!this.state.usrlist) {
      return (
        <React.Fragment>
        <div className="loaderCenter">
        <Loader></Loader>
        </div>
 
      </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            {/* Render Breadcrumbs */}
            {/* <Breadcrumbs title="Usuarios" breadcrumbItem="Lista de usuarios" /> */}
            <Button onClick={(event)=>this.refresh(event)} color="primary" className="btn btn-primary buttonStatus usersButtons" > <i size="lg" className="mdi  mdi-refresh"></i></Button>
            <Button onClick={(event)=>this.newUser(event)} className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
             
                     {this.props.t("Crear nuevo usuario")}
  
            </Button>
            <UsersList usrlist={this.state.usrlist}/>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { error, loadingGetUser, users, success } = state.GetUsers;
  return { error, loadingGetUser, users, success };
};

export default withRouter(
  connect(mapStateProps, {
    getUsers,
  })(withNamespaces()(Users))
);
